<template>
    <v-dialog persistent v-model="dialog" width=30%>
        <v-card>
            <div style="cursor:default">
                <v-card-title>Add text translation
                </v-card-title>       
                <v-card-text>
                <v-row class="px-4 pt-4">
                    <v-text-field v-model="vttk.code" label="Code" hide-details="auto" dense :error-messages="validation_message" 
                                  v-on:keydown="onKeydown($event)" 
                                  v-on:focus="onFocus($event)" ></v-text-field>
                </v-row>
                <v-row class="px-4 pt-4">
                    <v-text-field v-model="vttk.description" label="Description"></v-text-field>
                </v-row>    
                </v-card-text>
                <v-card-actions>
                    <v-spacer/><v-btn small color="primary" @click="saveVttk">save</v-btn><v-btn small color="primary" @click="close">close</v-btn>
                </v-card-actions>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
        },     
        mounted(){
        },   
        components: {
        },      
        data() {
            return {
                dialog: false,
                validation_message: '',
                vttk: {
                    code: '',
                    description: '',
                }
            }
        },
        methods: {                    
            open(){
                this.dialog=true;
                this.vttk.code = ''
                this.vttk.description = ''
            },    
            close(){
                this.validation_message = '';
                this.dialog=false;
            },
            onFocus(evt) {
                try {
                    evt.target.select();
                } catch (err) {
                    return;
                }
            },        
            onKeydown() {
                this.validation_message='';
            },                
            saveVttk(){
                this.$axios
                .post("ares/json/ares/syst/ref/vttk/saveVttk.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveVttk"
                    },
                    saveVttk: {
                        vttk: this.vttk
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.validation_message = res.data.error.message;
                    } else {                        
                        // doorstarten naar "lege" translation
                        this.$emit('updateData', {field: "recid", value: res.data.saveVttk.vttk_encrid});
                        this.close();
                    }
                })
            }
        }
    }

</script>

<style scoped>

</style>